import styled from 'styled-components';

import colors from 'constants/colors';

const Container = styled.div`
  position: sticky;
  left: 0;
  z-index: 1;
`;

const Row = styled.div`
  border-bottom: 1px solid ${colors.main.disabledBtns};

  &:first-child {
    border-top: 1px solid ${colors.main.disabledBtns};
  }
`;

const Cell = styled.div`
  width: 75px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.background.maincolor};

  @media screen and (max-width: 992px) {
    width: 45px;
    height: 70px;
  }
`;

const TextWrapper = styled.div`
  transform: rotate(-90deg);
`;

export { Container, Row, Cell, TextWrapper };
